import { lang, commonLang } from '@umu/ukit-lang';
/**
 * 学习群消息的格式化服务
 */

import { formatNumToMoney } from '@umu/umu-util';
import { config } from 'common';
const { SESSION_TYPE_NAMES } = config;

// 类型第一次定义时，以 courseHome 中的数据结构为基准
export interface IImMessageData {
    content: {
        data: {
            body: string;
            type: number;
            shareTitle: string;
            money: string;
            f_name: string;
            t_name: string;
        };
        type: number;
    };
    text: string;
    type: string;
    fromNick: string;
}

// 从 IM 拿过来的，后面看 IM 那边的这种数据怎么拆出来
enum ECustomMessageType {
    group = 11,
    session = 12,
    pinup = 13,
    recall = 14,
    add_like = 15,
    reward = 16,
    typeMuted = 17, // 分类禁言
    reply = 18, // 回复,
    remindEveryone = 19, // 全员提醒
}

function getSessionName(sessionType: number) {
    return SESSION_TYPE_NAMES[sessionType];
}

function getCustomMessageContent(messageData: IImMessageData) {
    const msg = messageData.content;
    const type = msg.type;
    const customData = msg.data;
    let content = '';
    switch (type) {
        case ECustomMessageType.group:
            content = lang('{$0} 分享了课程：{$1}', messageData.fromNick, customData.shareTitle);
            break;
        case ECustomMessageType.session:
            // tslint:disable-next-line:max-line-length
            content = lang(
                '{$0} 分享了 {$1}：{$2}',
                messageData.fromNick,
                getSessionName(customData.type),
                customData.shareTitle,
            );
            break;
        case ECustomMessageType.pinup:
            content = `${messageData.fromNick}${commonLang('：')}${lang('[贴图]')}`;
            break;
        case ECustomMessageType.reward:
            const from = customData.f_name || '';
            const to = customData.t_name || '';
            const money = lang('￥') + formatNumToMoney(parseInt(customData.money + '', 10) / 100);
            content = lang('{$0} 赞赏了 {$1} {$2}', from, to, money);
            break;
        case ECustomMessageType.remindEveryone:
            const name = messageData.fromNick;
            content = `${name} ${lang('发布了全员提醒')}`;
            break;
        default:
            content = '';
            break;
    }
    return content;
}

export const getMessageContent = (messageData: IImMessageData) => {
    let content = '';
    switch (messageData.type) {
        case 'TEXT':
            content = `${messageData.fromNick}${commonLang('：')}${messageData.text}`;
            break;
        case 'PICTURE':
            content = `${messageData.fromNick}${commonLang('：')}${lang('[图片]')}`;
            break;
        case 'FILE':
            content = `${messageData.fromNick}${commonLang('：')}${lang('[文件]')}`;
            break;
        case 'VIDEO':
            content = `${messageData.fromNick}${commonLang('：')}${lang('[视频]')}`;
            break;
        case 'AUDIO':
            content = `${messageData.fromNick}${commonLang('：')}${lang('[音频]')}`;
            break;
        case 'CUSTOM':
            content = getCustomMessageContent(messageData);
            break;
        case 'TIP':
            content = '';
            break;
        case 'NOTIFICATION':
            content = '';
            break;
        default:
            content = '';
            break;
    }
    return content;
};
